import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const getValidationSchema = (type) => {
  return yup.object({
    amount: yup.string().required("Amount is required"),
    destination_account_id: yup
      .number()
      .required("Destination bank is required"),
    description: yup.string().required("Description is required"),
    entry_date: yup.string().required("Transaction date is required"),
  });
};

const Validation = ({ type }) => {
  return useForm({
    resolver: yupResolver(getValidationSchema(type)),
    shouldFocusError: true,
    mode: "onBlur",
  });
};

export default Validation;
